import React, { PureComponent, Fragment } from "react";

import { getDateLabel, getUserNameForAvatar } from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";
import _ from "i18n";

import ClientEboxContainer from "../../Community/Common/Ebox/ClientEboxContainer";

export default class Content extends PureComponent {
  render() {
    const { lr } = this.props;
    const { id, firstName, lastName, mainEmail, mainPhone, language } = lr;

    return (
      <Fragment>
        <div className="cell rmodal__body">
          <div className={styles.header}>
            <div className={styles.avatar}>
              {getUserNameForAvatar(firstName, lastName)}
            </div>
            <div className={styles.infos}>
              <h4>{`${firstName} ${lastName}`}</h4>
              <ul>
                <li>
                  <label>{_("Email")}:</label>
                  <span>{mainEmail}</span>
                </li>
                <li>
                  <label>{_("Phone")}:</label>
                  <span>{mainPhone || ""}</span>
                </li>
                <li>
                  <label>{_("Language")}:</label>
                  <span>{language}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.body}>
            <ClientEboxContainer lrId={id} />
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/ClientEboxViewer/Content.js